import { Controller } from '@hotwired/stimulus'

// Mobile-only "+" button in each job's notes section on the worklist show
// page. The add-notes modal (and its `modal` + `job-notes` controllers) live
// on the job row's actions cell, one row above the notes section, so the
// button reaches across by job id and opens the same modal + lazy TinyMCE.
export default class extends Controller {
  static values = { jobId: Number }

  open() {
    const jobRow = document.querySelector(`table.work-list-table tr#job-${this.jobIdValue}`)
    if (!jobRow) return

    const actionsCell = jobRow.querySelector('td.actions-cell')
    if (!actionsCell) return

    const modal = this.application.getControllerForElementAndIdentifier(actionsCell, 'modal')
    if (modal) modal.open()

    const jobNotes = this.application.getControllerForElementAndIdentifier(actionsCell, 'job-notes')
    if (jobNotes) jobNotes.prepare()
  }
}
